module.exports = __webpack_public_path__ + "static/assets/4eca178c7adeca4d6d352c17823807c9.png";